import {
  HistoryAction,
  HistoryActionType,
  IHistoryState,
} from "../types/manyTargetCampaignsHistory"

const initialState: IHistoryState = {
  history: [],
  loading: false,
  error: null,
}

export const manyTargetCampaignsHistoryReducer = (
  state = initialState,
  action: HistoryAction
): IHistoryState => {
  switch (action.type) {
    case HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS:
      return {
        history: action.payload,
        loading: false,
        error: null,
      }
    case HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
